import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAssembly = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.89474 4L3 5.88886L4.33224 7.88102C4.68371 8.40706 5.27588 8.72215 5.90872 8.72215H6.3972L8.96176 11.2787L10.3014 9.94327L7.73684 7.38667V6.89969C7.73684 6.26882 7.42078 5.67849 6.89309 5.3281L4.89474 4ZM17.2105 4C15.1178 4 13.4211 5.69147 13.4211 7.77772C13.4211 8.33139 13.5468 8.85335 13.7615 9.32717L4.22492 18.8342C3.8545 19.2035 3.8545 19.8013 4.22492 20.1697L4.78002 20.723C5.14949 21.0923 5.74923 21.0923 6.11965 20.723L11.6484 15.2114L17.0736 20.6198C17.5814 21.126 18.4032 21.1269 18.911 20.6198L19.6715 19.8616C20.1793 19.3564 20.1793 18.5362 19.6715 18.0299L14.2463 12.6216L15.6562 11.216C16.1315 11.4301 16.6551 11.5554 17.2105 11.5554C19.3033 11.5554 21 9.86396 21 7.77772C21 7.22428 20.8746 6.70142 20.6595 6.22826L18.1579 8.72215L16.2632 6.83329L18.7648 4.3394C18.2902 4.12502 17.7657 4 17.2105 4Z",
		fill: "currentColor"
	})
});
export default SvgAssembly;
